import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Layout from '../../components/layout/Layout';
import OtherRenewableEnergyCreateModal from '../../modal/renewable_energy/OtherRenewableEnergyCreateModal';
import Constants from '../../config/constants';
import Thumbnail from '../../components/thumbnail/Thumbnail';
import { COLUMN_STYLE, getColumnStyle } from '../../components/datatable/util';
import Alert from '../../modal/alert/Alert';
import DataTable from '../../components/datatable/DataTable';
import {
  defaultRejectHandler,
  getErrorValue,
  withDefaultSort,
} from '../../utils/utility';
import {
  clearErrorOtherRenewableEnergy,
  deleteOtherRenewableEnergy,
  listOtherRenewableEnergy,
} from '../../redux/renewable_energy/other_renewable_energy_actions';
import Select from 'react-select';
import OtherRenewableEnergyEditModal from '../../modal/renewable_energy/OtherRenewableEnergyEditModal';
import OtherRenewableEnergyDuplicateModal from '../../modal/renewable_energy/OtherRenewableEnergyDuplicateModal';

class OtherRenewableEnergyPage extends React.Component {
  constructor(props) {
    super(props);
    this.search = {
      pageSize: Constants.DATA_TABLE_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    const coefficientColumn = getColumnStyle(COLUMN_STYLE.coefficient);
    const { t } = props;

    this.columns = [
      {
        Header: '',
        accessor: 'thumbnail',
        Cell: row => <Thumbnail img={row.value} />,
        ...getColumnStyle(COLUMN_STYLE.thumbnail),
      },
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'name',
        ...getColumnStyle(COLUMN_STYLE.text),
      },
      {
        Header: () => <b>{t('category')}</b>,
        accessor: 'is_public',
        Cell: row => row.value
          ? <span><i className="fas fa-users"/> {t('public')}</span>
          : <span><i className="fas fa-user"/> {t('private')}</span>,
        ...getColumnStyle(COLUMN_STYLE.category),
      },
      {
        Header: () => <b>{t('energy')} ({t('kWh/Year')})</b>,
        accessor: 'energy',
        ...coefficientColumn,
        width: 200,
      },
    ];

    this.state = {
      selectedInstance: null,
      categoryOption: 'all',
      isShowCreateModal: false,
      isShowEditModal: false,
      isShowDeleteModal: false,
      isShowDuplicateModal: false,
      isCreated: false,
      isEdited: false,
      isDuplicated: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isCreating && nextProps.isCreating !== this.props.isCreating && !nextProps.errorMessage) {
      this.setState({ isShowCreateModal: false, isCreated: true });
    }

    if (this.props.isEditing && nextProps.isEditing !== this.props.isEditing && !nextProps.errorMessage) {
      this.setState({ isShowEditModal: false, isEdited: true });
    }

    if (this.props.isDeleting && nextProps.isDeleting !== this.props.isDeleting && !nextProps.errorMessage) {
      this.setState({ isShowDeleteModal: false });
    }

    if (this.props.isDuplicating && nextProps.isDuplicating !== this.props.isDuplicating && !nextProps.errorMessage) {
      this.setState({ isShowDuplicateModal: false, isDuplicated: true });
    }
  }

  renderActionMenu() {
    const { t } = this.props;
    return [
      <li>
        <a
          href="#"
          id="other-renewable-energy-create"
          data-toggle="modal"
          data-target="#create-other-renewable-energy"
          onClick={() => this.setState({ isShowCreateModal: true, isCreated: false })}
        >
          <i className="fas fa-plus-square" />
          <span className="menu-text">{t('create other renewable energy')}</span>
        </a>
      </li>,
    ];
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;

    this.props.listOtherRenewableEnergy(
      this.search.pageSize,
      this.search.page,
      withDefaultSort(this.search.sorted),
      this.search.filtered,
      {
        all: null,
        public: true,
        private: false,
      }[category.value],
    );

    this.setState({ categoryOption: category });
  }

  dismissCreateModal() {
    this.props.clearError();
    this.setState({ isShowCreateModal: false });
  }

  dismissEditModal() {
    this.props.clearError();
    this.setState({ isShowEditModal: false });
  }

  dismissDeleteModal() {
    this.props.clearError();
    this.setState({ isShowDeleteModal: false });
  }

  dismissDuplicateModal() {
    this.props.clearError();
    this.setState({ isShowDuplicateModal: false });
  }

  render() {
    const {
      selectedInstance: instance,
      isShowCreateModal,
      isShowEditModal,
      isShowDeleteModal,
      isShowDuplicateModal,
    } = this.state;

    const {
      filteredCount,
      isLoading,
      isDeleting,
      isDuplicating,
      t,
      errorMessage,
    } = this.props;

    const breadcrumbItems = [
      { name: t('renewable energy'), path: '/renewable_energy' },
      { name: t('other renewable energy'), path: '/renewable_energy/other_renewable_energy' },
    ];

    const helpConfig = {
      title: t('help'),
      contentUrl: '/html/help_renewable_energy.html',
    };

    return (
      <Layout
        history={this.props.history}
        breadcrumbItems={breadcrumbItems}
        renderActionMenu={() => this.renderActionMenu()}
        help={helpConfig}
      >
        <OtherRenewableEnergyCreateModal
          show={isShowCreateModal}
          isCreated={this.state.isCreated}
          onHide={() => this.dismissCreateModal()}
        />
        <OtherRenewableEnergyEditModal
          renewableEnergy={instance}
          show={isShowEditModal}
          isEdited={this.state.isEdited}
          onHide={() => this.dismissEditModal()}
        />
        <OtherRenewableEnergyDuplicateModal
          item={instance}
          show={isShowDuplicateModal}
          title={t('copy other renewable energy')}
          label={t('new other renewable energy name')}
          isDuplicated={this.state.isDuplicated}
          onHide={() => !isDuplicating && this.dismissDuplicateModal()}
        />
        <Alert
          show={isShowDeleteModal}
          onHide={() => !isDeleting && this.dismissDeleteModal()}
          title={t('delete other renewable energy')}
          body={`${t('do you want to delete')} ${instance ? instance.name : ''}?`}
          errorMessage={getErrorValue(errorMessage, 'detail')}
          primaryButtonTitle={isDeleting ? `${t('deleting')}...` : t('delete')}
          primaryButtonStyle="danger"
          primaryButtonEnabled={!isDeleting}
          onPrimaryButtonClick={() => this.props.deleteRenewableEnergy(instance)}
        />
        <h1>{t('other renewable energy')}</h1>
        <div style={{ backgroundColor: 'white' }}>
          <div className="filter-box" style={{ display: 'flex', padding: 20, marginBottom: 20 }}>
            <input
              id="other-renewable-energy-search-name"
              className="text-search"
              style={{ width: 240, height: 36, margin: 10 }}
              type="text"
              onChange={event => this.updateSortFilter(event.target.value, null, this.state.categoryOption)}
              placeholder={t('search name')}
            />
            <Select
              className="react-select-container"
              classNamePrefix="react-select"
              style={{ width: 160, margin: 10 }}
              value={this.state.categoryOption}
              placeholder={t('category')}
              onChange={option => this.updateSortFilter(this.search.filtered, null, option)}
              options={[
                { value: 'all', label: t('all') },
                { value: 'public', label: t('public') },
                { value: 'private', label: t('private') },
              ]}
            />
          </div>
          <DataTable
            columns={this.columns}
            data={this.props.instances}
            onActionEdit={item => this.setState({ isShowEditModal: true, selectedInstance: item.original, isEdited: false })}
            onActionDuplicate={item => this.setState({ isShowDuplicateModal: true, selectedInstance: item.original, isDuplicated: false })}
            onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedInstance: item.original })}
            filteredCount={filteredCount}
            isLoading={isLoading}
            onFetchData={state => this.updateSortFilter(this.search.filtered, state, this.state.categoryOption)}
          />
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  const renewableEnergyState = state.renewableEnergy.otherEnergy;
  return {
    instances: renewableEnergyState.orderedIds.map(id => renewableEnergyState.items[id]),
    filteredCount: renewableEnergyState.filteredCount,
    isLoading: renewableEnergyState.isLoading,
    isCreating: renewableEnergyState.isCreating,
    isEditing: renewableEnergyState.isEditing,
    isDeleting: renewableEnergyState.isDeleting,
    isDuplicating: renewableEnergyState.isDuplicating,
    errorMessage: renewableEnergyState.errorMessage,
  };
};

const mapDispatchToProps = dispatch => ({
  listOtherRenewableEnergy: (pageSize, page, sorted, filtered, isPublic) =>
    defaultRejectHandler(
      dispatch(listOtherRenewableEnergy(pageSize, page, sorted, filtered, isPublic))
    ),
  deleteRenewableEnergy: renewableEnergy =>
    defaultRejectHandler(dispatch(deleteOtherRenewableEnergy(renewableEnergy.id))),
  clearError: () => dispatch(clearErrorOtherRenewableEnergy()),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(OtherRenewableEnergyPage)
);



// WEBPACK FOOTER //
// ./src/pages/renewable_energy/OtherRenewableEnergyPage.js